import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'loanDesiredAmount',
    'ownFundAmount',
    'otherLoan',
    'purchasePurpose',
    'purchasePurposeOther',
    'workStyle',
    'workStyleOther',
  ]

  connect() {
    this.accordionRequest()
  }

  accordionRequest() {
    let ele = $('.js-request-accordion')
    if (ele.length > 0) {
      ele.on('click', function () {
          $(this).toggleClass('is-active')
          $(this).prev().slideToggle(300)
      })
    }
    this.openAccordion()
  }

  openAccordion() {
    let openAccordionTarget = $('.js-request-accordion').eq(0)
    openAccordionTarget.toggleClass('is-active')
    openAccordionTarget.prev().slideToggle(300)
  }

  useLoanChanged(e) {
    const loanDesiredAmountTarget = this.loanDesiredAmountTarget
    const ownFundAmountTarget = this.ownFundAmountTarget
    const otherLoanTarget = this.otherLoanTarget

    if (e.currentTarget.value == 'true') {
      loanDesiredAmountTarget.required = true
      loanDesiredAmountTarget.readOnly = false
      loanDesiredAmountTarget.classList.remove('readonly')
      loanDesiredAmountTarget.previousElementSibling.lastChild.classList.remove('hidden')

      ownFundAmountTarget.required = true
      ownFundAmountTarget.readOnly = false
      ownFundAmountTarget.classList.remove('readonly')
      ownFundAmountTarget.previousElementSibling.lastChild.classList.remove('hidden')

      otherLoanTarget.required = true
      otherLoanTarget.disabled = false
      otherLoanTarget.classList.remove('readonly')
      otherLoanTarget.previousElementSibling.lastChild.classList.remove('hidden')
    } else {
      loanDesiredAmountTarget.required = false
      loanDesiredAmountTarget.readOnly = true
      loanDesiredAmountTarget.classList.add('readonly')
      loanDesiredAmountTarget.value = ''
      loanDesiredAmountTarget.previousElementSibling.lastChild.classList.add('hidden')

      ownFundAmountTarget.required = false
      ownFundAmountTarget.readOnly = true
      ownFundAmountTarget.classList.add('readonly')
      ownFundAmountTarget.value = ''
      ownFundAmountTarget.previousElementSibling.lastChild.classList.add('hidden')

      otherLoanTarget.required = false
      otherLoanTarget.disabled = true
      otherLoanTarget.classList.add('readonly')
      otherLoanTarget.previousElementSibling.lastChild.classList.add('hidden')
    }
  }

  purchasePurposeChanged() {
    const purchasePurposeTarget = this.purchasePurposeTarget
    const purchasePurposeOtherTarget = this.purchasePurposeOtherTarget

    if (purchasePurposeTarget.value == 'その他') {
      purchasePurposeTarget.required = false
      purchasePurposeTarget.classList.add('readonly')
      purchasePurposeTarget.previousElementSibling.lastChild.classList.add('hidden')

      purchasePurposeOtherTarget.required = true
      purchasePurposeOtherTarget.readOnly = false
      purchasePurposeOtherTarget.classList.remove('readonly')
      purchasePurposeOtherTarget.previousElementSibling.lastChild.classList.remove('hidden')
    } else {
      purchasePurposeTarget.required = true
      purchasePurposeTarget.classList.remove('readonly')
      purchasePurposeTarget.previousElementSibling.lastChild.classList.remove('hidden')

      purchasePurposeOtherTarget.required = false
      purchasePurposeOtherTarget.readOnly = true
      purchasePurposeOtherTarget.classList.add('readonly')
      purchasePurposeOtherTarget.value = ''
      purchasePurposeOtherTarget.previousElementSibling.lastChild.classList.add('hidden')
    }
  }

  workStyleChanged() {
    const workStyleTarget = this.workStyleTarget
    const workStyleOtherTarget = this.workStyleOtherTarget

    if (workStyleTarget.value == 'その他') {
      workStyleTarget.required = false
      workStyleTarget.classList.add('readonly')
      workStyleTarget.previousElementSibling.lastChild.classList.add('hidden')

      workStyleOtherTarget.required = true
      workStyleOtherTarget.readOnly = false
      workStyleOtherTarget.classList.remove('readonly')
      workStyleOtherTarget.previousElementSibling.lastChild.classList.remove('hidden')
    } else {
      workStyleTarget.required = true
      workStyleTarget.classList.remove('readonly')
      workStyleTarget.previousElementSibling.lastChild.classList.remove('hidden')

      workStyleOtherTarget.required = false
      workStyleOtherTarget.readOnly = true
      workStyleOtherTarget.classList.add('readonly')
      workStyleOtherTarget.value = ''
      workStyleOtherTarget.previousElementSibling.lastChild.classList.add('hidden')
    }
  }
}
